<svg xmlns="http://www.w3.org/2000/svg"
     xmlns:xlink="http://www.w3.org/1999/xlink"
     version="1.1"
     [attr.role]="role"
     aria-hidden="true"
     focusable="false">
    <defs [innerHTML]="_defs" *ngIf="_defs"> </defs>
    <use [attr.xlink:href]="('#' + _use)"
         [attr.href]="('#' + _use)">
    </use>
</svg>
